import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { GridRendererParams } from "./grid-action-callbacks.model";
import { GridActionsCellItem, GridActionType } from "./actions-cell-item.model";
import { NbMenuItem } from "@nebular/theme";

@Component({
    selector: "kno2-actions-cell-renderer",
    templateUrl: "./actions-cell-renderer.component.html",
    styleUrls: ["./actions-cell-renderer.component.scss"],
    standalone: false
})
export class ActionsCellRendererComponent implements ICellRendererAngularComp {
    public params: GridRendererParams;
    public itemsByAction: Record<GridActionType, Array<NbMenuItem>> = {} as any;

    public refresh(params: ICellRendererParams): boolean {
        throw new Error("Method not implemented.");
    }

    public agInit(params: GridRendererParams): void {
        this.params = params;
        this.setupDropdownMenus();
    }

    public handleAction(action: GridActionsCellItem, event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        this.params.actionCallbacks[action.type](this.params.data, (isLoading: boolean) => (action.isLoading = isLoading));
    }

    public handleMenuItemClick(item: NbMenuItem): void {
        const type = item.data.type as string;
        const callback = this.params.context.menu.callbacks?.[type];
        if (callback) callback(this.params.data);
    }

    /**
     * Call this to convert the passed in menu items into
     * a nebular-compatible NbMenuItem array
     */
    private setupDropdownMenus(): void {
        this.handleMenuItemClick = this.handleMenuItemClick.bind(this);

        this.itemsByAction = this.params.actionItems
            .filter(({ dropdown }) => dropdown)
            .reduce(
                (prev, actionItem) => ({
                    ...prev,
                    [actionItem.type]: this.generateMenuItems(actionItem)
                }),
                {} as any
            );
    }

    private generateMenuItems(item: GridActionsCellItem): Array<NbMenuItem> {
        return (item.dropdown?.menuItems || [])
            .filter(({ hidden }) => !hidden)
            .map(
                ({ type, title, icon }) =>
                    ({
                        title,
                        icon,
                        data: {
                            type
                        }
                    }) as NbMenuItem
            );
    }
}
